// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#mobileTemplateWrapper {\n  position: relative;\n}\n", "",{"version":3,"sources":["webpack://./assets/js/productpage/templates/mobile/aboveFoldStyle.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF","sourcesContent":["#mobileTemplateWrapper {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
